module.exports = __webpack_public_path__ + "static/media/Title.9496560a.png";